<template>
    <component :is="tag" style="height: 100%">
        <slot
            :product="wizardProduct"
            :add-product="addProduct"
            :campaign="campaign"
            :is-loading="isLoading"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";
    import EventTrackingMixin from "../../../mixins/EventTrackingMixin";

    import {
        LIVE_CAMPAIGN_PROPOSAL_VIEW_PRODUCT_DETAILS_EVENT,
        LIVE_CAMPAIGN_PROPOSAL_ADD_PRODUCT_EVENT,
    } from '../../../constants/analytics-events';

    export default {
        name: 'ProductWizardProvider',
        mixins: [
            BaseProposalStepMixin,
            EventTrackingMixin,
        ],
        data() {
          return {
              isLoading: false,
          }
        },
        watch: {
            $route() {
                this.loadProduct();
            },
        },
        methods: {
            addProduct(payload, index) {
                (index === null || index === undefined) ? this.$root.v2.loadedProducts.push(payload) : this.$root.v2.loadedProducts[index] = payload;
                this.$router.push({name: 'v2.campaign.proposal.products'});
                this.$bus.$emit(LIVE_CAMPAIGN_PROPOSAL_ADD_PRODUCT_EVENT);
                this.trackEventProductAdded(this.campaign.id);
            }
        },
        created() {
            this.$bus.$emit(LIVE_CAMPAIGN_PROPOSAL_VIEW_PRODUCT_DETAILS_EVENT);

            this.isLoading = true;

            return this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadProduct(),
                        this.loadProposal(),
                        this.loadCampaign()
                    ])
                })
                .catch((error) => {
                    this.handleHttpError(error)
                })
                .then(() => {
                    this.isLoading = false;
                })
        }
    }
</script>
